import client from './client';

let cachedPromise = null;

export default {
    getUnitLabels: () => client.get('api/unit-labels'),
    // Reference data barely ever changes - fetch it once per page load and
    // share the same in-flight/resolved request across every consumer
    // instead of hitting the API again on each mount (table, filters, ...).
    getUnitLabelsCached: () => {
        if (!cachedPromise) {
            cachedPromise = client.get('api/unit-labels');
        }
        return cachedPromise;
    },
    invalidateCache: () => {
        cachedPromise = null;
    },
};
